import PropTypes from 'prop-types';
import React from 'react';

import Form from '../../../gd-form/form/form-modal-new/form-modal-new.tsx';
import FormError from '../../../gd-form/common/form-error/form-error.tsx';
import FormManager from '../../../gd-form/common/form-manager';

import Input from '../../../gd-form/form-element/input/input.jsx';

class AddDepartmentModal extends React.Component {
    static propTypes = {
        // You can declare that a prop is a specific JS primitive. By default, these
        // are all optional.
        // params: PropTypes.object.isRequired

        onSubmit: PropTypes.func.isRequired,
        name: PropTypes.string,
        autofocus: PropTypes.bool
    };

    componentDidMount() {
        if (this.props.autofocus) this.refs['name'].focus();
    }

    UNSAFE_componentWillMount() {

        const initFormData = {
            name: this.props.name ? this.props.name : ''
        };

        const formStructure = {
            fields: {
                name: {
                    type: 'input',
                    isRequired: true,
                    label: 'Name'
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.onSubmit(result); //.call(this.props.params.this,result);
    };

    render() {

        return (
            <Form form={this.form}>

                <div className="tbl">

                    <div className="row">
                        <div className="label">Department name</div>

                        <div className="element">
                            <Input size="big" form={this.form} name="name" ref="name"/>
                            <FormError form={this.form} name="name" />
                        </div>

                    </div>


                </div>




            </Form>
        );
    }
}

module.exports = AddDepartmentModal;